import axios from 'axios';
import csrfToken from '../../../../shared/meta';
import axiosConfig from '../../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

const headers = { 'X-CSRF-TOKEN': csrfToken() };

const base = '/api/v1/lwadmin/series_configuration';

export function useGetSeriesConfiguration() {
  return useAxios({
    cache: { ignoreCache: true },
    url: base,
    method: 'GET',
  }, { manual: true });
}

export function saveSeriesConfiguration(payload) {
  return axios.post(base, payload, { headers });
}
